/**
 * @voltxampere/ui — Active piezo buzzer 5V (Sprint 51-1 polish)
 *
 * Self-oscillating piezo buzzer — internal driver IC generates the
 * tone. Apply 5V → audible beep (~2.7 kHz). No PWM signal required.
 * Ideal for alarm circuits, doorbell projects, simple notifications.
 *
 * Modeled as load resistance ~32Ω (typical buzzer impedance).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (passive sound output; real models would need acoustic transducer
 * canonical type — Sprint 52+ polish).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const buzzerActive = {
    id: "buzzer-active-5v",
    nameTr: "Aktif Piezo Buzzer 5V (yerleşik osilatör)",
    nameEn: "Active Piezo Buzzer 5V (built-in oscillator)",
    shortcut: "B",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "BZ",
    defaultValue: "5V Active",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        deviceType: "piezo-buzzer-active",
        operatingV: 5,
        typicalCurrentMa: 30,
        frequencyHz: 2700,
        soundPressureDb: 85,
        requiresPwm: false,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=buzzer-active.js.map